module.exports = __webpack_public_path__ + "img/icon-white-20.6550e388.svg";